import {Component, ChangeDetectionStrategy, Input, Inject} from '@angular/core';
import {CurrentUser} from 'app/core/services/auth.service';
import {DemoService} from 'app/core/services/demo.service';
import {AuthBridgeService} from 'app/features/auth-bridge-ext/services/auth-bridge.service';
import {AppUrls} from 'app/core/url/app-urls.service';
import {I18NEXT_SERVICE, ITranslationService} from 'angular-i18next';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
    @Input() termsLink;
    @Input() buildInfo;
    @Input() currentUser: CurrentUser;
    @Input() mobileFooter: boolean;
    @Input() isPageWithoutHeader: boolean;

    currentYear = new Date().getFullYear();

    appUrls = AppUrls;

    constructor(
        @Inject(I18NEXT_SERVICE) public i18Next: ITranslationService,
        public demo: DemoService,
        public bridgeService: AuthBridgeService
    ) {}

    navigateToSignFromDemoUpPage() {
        document.location.href = 'https://app.appodeal.com/signup';
    }
}
